export default {
	'show-all-columns': 'عرض كل الأعمدة',
	'total-arrested': ' مجموع المقبوضات:',
	'total-payments': ' مجموع المدفوعات:',
	'the-difference': 'الفرق:'
}